import "./main.scss";
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "./store";
import { ContentArea, Workspace } from "@episerver/ui-framework";
import { Switch, Route, HashRouter as Router, Redirect } from "react-router-dom";
import ContactDetail from "./ContactManager/components/ContactDetail";
import ContactList from "./ContactManager/components/ContactList";
import {ContactsType, ContactType} from "./ContactManager/model/contact"
import EnumForm from "./EnumManager/components/EnumForm";
import EnumList from "./EnumManager/components/EnumList";
import OrganizationList from "./OrganizationManager/components/OrganizationList";
import OrganizationDetail from "./OrganizationManager/components/OrganizationDetail";
import AddressForm from "./AddressManager/components/AddressForm";
import { InView } from "./AddressManager/model/address";
import "./global.scss";
import "../businessFoundation/axiom/dist/styles.scss";


export enum CustomersType {
    Users, 
    Accounts,
    Contacts,
    Organizations
}

function getCustomersApp(type: CustomersType) {
    const CustomersApp: FunctionComponent = () => {
        return (
            <div className="content-area-container">
                <Provider store={store}>
                    <div className="customers-container">
                        <ContentArea>
                            <Workspace>
                                <Router>
                                    <Switch>
                                        <Route
                                            exact
                                            path={`/`}
                                            render={() => <Redirect to={`/${CustomersType[type]}`} />}
                                        />
                                        <Route path={`/Contacts/Edit/:contactId?`}>
                                            <EnumForm />
                                            <AddressForm inView={InView.Contact} />
                                            <ContactDetail type={ContactType.Contact}/>
                                        </Route>
                                        <Route path={`/Users/Edit/:contactId?`}>
                                            <EnumForm />
                                            <AddressForm inView={InView.Contact} />
                                            <ContactDetail type={ContactType.User}/>
                                        </Route>
                                        <Route path={`/Accounts/Edit/:contactId?`}>
                                            <EnumForm />
                                            <AddressForm inView={InView.Contact} />
                                            <ContactDetail type={ContactType.Account}/>
                                        </Route>
                                        <Route path={`/Contacts`}>
                                            <ContactList type={ContactsType.Contacts}/>
                                        </Route>
                                        <Route path={`/Users`}>
                                            <ContactList type={ContactsType.Users}/>
                                        </Route>
                                        <Route path={`/Accounts`}>
                                            <ContactList type={ContactsType.Accounts}/>
                                        </Route>
                                        <Route path={`/Organizations/Edit/:organizationId?`}>
                                            <AddressForm inView={InView.Organization} />
                                            <EnumForm />
                                            <OrganizationDetail />
                                        </Route>
                                        <Route path={`/Organizations`}>
                                            <OrganizationList />
                                        </Route>
                                        <Route path={`/Enums/:type`}>
                                            <EnumForm />
                                            <EnumList />
                                        </Route>
                                    </Switch>
                                </Router> 
                            </Workspace>
                        </ContentArea>
                    </div>
                </Provider>
            </div>
        );
    }

    return CustomersApp;
} 


export const Contacts = getCustomersApp(CustomersType.Contacts);
export const Organizations = getCustomersApp(CustomersType.Organizations);
export const Users = getCustomersApp(CustomersType.Users);
export const Accounts = getCustomersApp(CustomersType.Accounts);
